var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9996 15.541C11.5856 15.541 11.2496 15.205 11.2496 14.791V4.56685L9.6156 6.2077C9.4696 6.3557 9.2766 6.4287 9.0846 6.4287C8.8936 6.4287 8.7016 6.3557 8.5556 6.2097C8.2626 5.9177 8.2606 5.4437 8.5536 5.1497L11.4435 2.24686C11.5808 2.09527 11.7791 2 11.9996 2C12.22 2 12.4183 2.09524 12.5556 2.24678L15.4466 5.1497C15.7386 5.4437 15.7376 5.9177 15.4446 6.2097C15.1506 6.5017 14.6766 6.5017 14.3846 6.2077L12.7496 4.56653V14.791C12.7496 15.205 12.4136 15.541 11.9996 15.541ZM17.565 22.5381H6.435C3.99 22.5381 2 20.5491 2 18.1031V13.2281C2 10.7831 3.99 8.7941 6.435 8.7941H7.368C7.782 8.7941 8.118 9.1301 8.118 9.5441C8.118 9.9581 7.782 10.2941 7.368 10.2941H6.435C4.816 10.2941 3.5 11.6101 3.5 13.2281V18.1031C3.5 19.7221 4.816 21.0381 6.435 21.0381H17.565C19.183 21.0381 20.5 19.7221 20.5 18.1031V13.2191C20.5 11.6061 19.188 10.2941 17.576 10.2941H16.633C16.219 10.2941 15.883 9.9581 15.883 9.5441C15.883 9.1301 16.219 8.7941 16.633 8.7941H17.576C20.015 8.7941 22 10.7791 22 13.2191V18.1031C22 20.5491 20.01 22.5381 17.565 22.5381Z",
    fill: "#115099"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.84c14910.svg";
export { ForwardRef as ReactComponent };